<script>
export default {
  mounted() {
    document.title = 'Katherine Watts Martinez Photography - About'
  }
}
</script>
<template>
  <div class="container">
    <h1 class="py-5">About Katherine Watts Martinez
    </h1>
    <h2 class="mb-5">Our Team</h2>
    <div class="row mb-5">
      <div class="col-md-6 offset-md-0 col-10 offset-1 mb-5">
        <div class="card h-100 text-center">
          <img class="card-img-top mb-4" src="../assets/headshot.jpg" alt="">
          <div class="card-body">
            <h4 class="card-title">KATHRYN WATTS-MARTINEZ</h4>
            <h6 class="card-subtitle mb-4 text-muted">Professional Photographer</h6>
            <p class="card-text mb-4"></p>
          </div>
          <div class="card-footer">
            <p>BUDA, TEXAS 78610</p>
            <p><a href="tel:512.659.7797">512.659.7797</a></p>
            <p><a href="mailto:#">KATHRYN@KWMPHOTO.COM</a></p>
          </div>
        </div>
      </div>
    </div>
    <!-- /.row -->
  </div>
</template>